import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {useAuth} from '../modules/auth'
import AmountNotWithDrawn from '../pages/amountnotwithdrawn/AmountNotWithDrawn'
import News from '../pages/news/News'
import Formularios from '../pages/forms/Formularios'
import Covenant from '../pages/Covenant'
import Faq from '../pages/Faq'
import AboutUs from '../pages/AboutUs'
import ContactUs from '../pages/ContactUs'
import Maintenance from '../pages/Maintenance'
// import Bills from '../pages/Bills' // Deshabilitado junto con la ruta /facturas
import PaymentDetail from '../pages/paymentdetail/PaymentDetail'
import EvolutionaryChartPayments from '../pages/evolutionarychartpayments/EvolutionaryChartPayments'
import Tariff from '../pages/Tariff'
import MailBoxPam from '../pages/MailBoxPam'
import AccountResume from '../pages/AccountResume'
import AccountResumeAnual from '../pages/AccountResumeAnual'
import AccountDetail from '../pages/AccountDetail'
import EvolutionaryChart from '../pages/EvolutionaryChart'
import AccountMedicalTeam from '../pages/AccountMedicalTeam'
import NewsLetter from '../pages/NewsLetter'
import Documents from '../pages/Documents'
import Marketplace from '../pages/Marketplace'
import MyProducts from '../pages/Marketplace/My-Products'
import Visits from '../pages/Visits'


const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const BecomePartnerPage = lazy(() => import('../pages/becomepartner/BecomePartner'))
  const ProcessPaymentPage = lazy(() => import('../pages/processpayment/ProcessPayment'))
  
  // Inicio Sesión de 20 minutos
  const {auth} = useAuth();
  const date = new Date();
  const date_now = Number(date.setTime(date.getTime()));
  const dateToken = auth?.dateExpired;

  if (dateToken && date_now > parseInt(dateToken)) {
    return <Navigate to='/logout' />;
  }
  // Fin Sesión de 20 minutos

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to={auth?.categoria === 'FIRMANTE' ? '/documentos' : '/inicio'} />} />
        {/* Pages */}
        <Route path='/' element={<Navigate to={auth?.categoria === 'FIRMANTE' ? '/documentos' : '/inicio'} />} />
        <Route path='inicio' element={<DashboardWrapper />} />
        <Route path='/pagos/monto-no-retirado' element={<AmountNotWithDrawn />} />
        <Route path="/noticias/view/:slug" element={<News />} />
        <Route path="/noticias/:slug" element={<News />} />
        <Route path="/hazte-socio" element={<BecomePartnerPage />} />
        <Route path="/pago-prestaciones" element={<ProcessPaymentPage />} />
        <Route path="/formularios" element={<Formularios />} />
        {/* Deshabilitado: dependía de auth/docelectronico/document, apagado por no uso (ver .claude/docs/ANALISIS_PRIVATIZACION_INTRANET.md en amsm) */}
        {/* <Route path="/facturas" element={<Bills />} /> */}
        <Route path="/aranceles" element={<Tariff />} />
        <Route path="/documentos" element={<Documents />} />
        <Route path="/buzonpam" element={<MailBoxPam />} />
        <Route path="/contactenos" element={<ContactUs />} />
        <Route path="/mantenimiento" element={<Maintenance />} />
        <Route path="/nosotros" element={<AboutUs />} />
        {auth?.profesionalAsociado && <Route path="/convenios" element={<Covenant />} />}
        <Route path="/preguntas-frecuentes" element={<Faq />} />
        <Route path="/pagos/detalle" element={<PaymentDetail />} />
        <Route path="/grafico/evolutivo/payments" element={<EvolutionaryChartPayments />} />
        <Route path="/grafico/evolutivo" element={<EvolutionaryChart />} />
        <Route path="/resumen-cuentas" element={<AccountResume />} />
        <Route path="/resumen-anual" element={<AccountResumeAnual />} />
        <Route path="/detalle-cuenta" element={<AccountDetail />} />
        <Route path="/equipo/medico" element={<AccountMedicalTeam />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='newsletter' element={<NewsLetter />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='/marketplace'
          element={
            <SuspensedView>
              <Marketplace />
            </SuspensedView>
          }
        />
        <Route
          path='/marketplace/my-notices'
          element={
            <SuspensedView>
              <MyProducts />
            </SuspensedView>
          }
        />
        <Route
          path='/visits'
          element={
            <SuspensedView>
              <Visits />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
